import pulse from "@finn-no/pulse-sdk";
import { IconCheck16 } from "@warp-ds/icons/react/check-16";
import { Box, Button } from "@warp-ds/react";
import React from "react";
import { DbaLogo } from "./DbaLogo.js";

export const DbaBox: React.FC = () => {
	const targetUrl = "/mobility/create/vehicle-lookup?model=car-used";

	const trackClick = () => {
		pulse.trackEvent({
			name: "Car lookup",
			type: "Click",
			intent: "Open",
			object: {
				type: "UIElement",
				elementType: "Button",
				id: "nyBilAnnonseBtn",
			},
			target: {
				type: "Page",
				pageType: "product_description",
				id: `${targetUrl}`,
			},
			vertical: {
				name: "mobility",
			},
		});
	};

	return (
		<>
			<Box bordered className="flex flex-col justify-between h-full">
				<div className="md:mb-16 flex-grow">
					<div className="mb-24">
						<DbaLogo />
					</div>
					<h2 className="h3 mb-8 flex items-center">Sælg bilen selv på DBA</h2>
					<p className="h4 mb-16">Du håndterer salget selv og får den højeste pris for bilen.</p>
					<p className="mb-24">
						På DBA gør vi det nemt og hurtigt for dig at sælge din bil, uanset om køberen er en privatperson eller en
						forhandler.
					</p>
					<div className="flex-col">
						<div className="flex cols-2 items-center mb-8">
							<IconCheck16 className="s-icon-positive mr-8" />
							Få højeste pris for bilen.
						</div>
						<div className="flex cols-2 items-center mb-8">
							<IconCheck16 className="s-icon-positive mr-8" />
							Eksponering til et stort og bredt publikum
						</div>
						<div className="flex cols-2 items-center mb-8">
							<IconCheck16 className="s-icon-positive mr-8" />
							Sælg til både private købere og forhandlere
						</div>
					</div>
				</div>
				<div className="mt-auto mb-16">
					<Button href="/mobility/create?model=car-used" fullWidth onClick={trackClick}>
						Opret annoncen
					</Button>
				</div>
				<p className="text-12 mt-4">
					Pris fra 79 kr for 14 dages annoncering, afhænger af køretøjets salgspris, annoncens varighed og eksponering.
				</p>
			</Box>
		</>
	);
};
